import styled from 'styled-components';

export const ArtefactsContainer = styled.div`
  /* width: 100vw; */
  width: 90%;
  min-height: 100vh;
  padding: 5rem calc((100vw - 1300px) / 2);
  background: #fff;
  color: black;
  margin-left: 60px
`;


export const ArtefactWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
`;


export const ArtefactCard = styled.div`
  margin: 0 2rem;
  line-height: 2;
  width: 300px;
`;

export const ArtefactImg = styled.img`
  height: 300px;
  min-width: 300px;
  max-width: 100%;
  box-shadow: 8px 8px #ffe560;
`;

export const ArtefactsHeading = styled.h1`
  font-size: clamp(1.7rem, 2.5vw, 3rem);
  text-align: center;
  margin-left: 0;
  margin-bottom: 2rem;
  background-color: #ffe560;
  
`;
export const ArtefactsHeading1 = styled.h1`  
font-size: clamp(1.2rem, 1.5vw, 2rem);
  text-align: left;
  margin-left: 2rem;
  margin-bottom: 3rem;
  margin-top: 2rem;
`;

export const Title = styled.h2`
  font-weight: 400;
  font-size: 1.2rem;
  font-family: 'Lora', serif;
  font-weight: bolder;
  
`;


export const ArtefactsHeading2 = styled.h1`  
font-size: clamp(1rem, 1.7vw, 3rem);
  text-align: left;
  margin-left: 3rem;
  margin-bottom: 3rem;
  margin-top: 2rem;
`;


export const ArtefactInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  text-align: center;
  font-family: 'Lora', serif;
    font-weight: bolder;
`;

export const Desc = styled.p`
  margin-bottom: 1rem;
  color: black;
  text-align: justify;
  font-family: 'Lora', serif;
font-weight: lighter;
`;